/*global TTTimeUnitEnum */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { Redirect }         from 'react-router-dom';

import { Dialog } from 'moovila-common';

import CheckForDirtyUtility from '../../utilities/checkForDirty';

const timeUnitOptions = [
  <option value={TTTimeUnitEnum.TU_DAY} key={1}>Days</option>,
  <option value={TTTimeUnitEnum.TU_MONTH} key={2}>Months</option>,
  <option value={TTTimeUnitEnum.TU_YEAR} key={3}>Years</option>,
]

class AddEditLicense extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      isActive: true,
      name: '',
      description: '',
      permissions: [],
      sku: '',
    };
    this.updateFeature        = this.updateFeature.bind(this);
    this.handleChange         = this.handleChange.bind(this);
    this.handleDisabledChange = this.handleDisabledChange.bind(this);
    this.handleSubmit         = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    if (this.props.features && !this.props.features.length) {
      this.setState({
        redirect: true,
      });
      return;
    }

    const freshState = {
      isActive: this.props.license ? this.props.license.isActive : true,
      name: this.props.license ? this.props.license.name : '',
      description: this.props.license ? this.props.license.description : '',
      sku: this.props.license ? this.props.license.sku : '',
      licenseGUID: this.props.license ? this.props.license.licenseGUID : null,
      createdDate: this.props.license ? this.props.license.createdDate : new Date().toISOString(),
      permissions: this.props.features ? this.props.features.map(f => {
        return {
          name: f.name,
          code: f.code,
          category: f.category,
          universal: f.universal,
          isSelected: this.props.license ? this.props.license.permissions.some(feature => feature.code === f.code) : false,
        }
      }) : [],
    }

    this.setState({ ...freshState });
    this.checkForDirty = CheckForDirtyUtility(freshState);
  }

  getFeature(code) {
    return this.state.permissions.filter(f => f.code === code)[0];
  }

  updateFeature(e, code) {
    const feature = this.getFeature(code);
    const newpermissions = [
      ...this.state.permissions.filter(f => f.code !== code),
      {
        name: feature.name,
        code: code,
        category: feature.category,
        universal: feature.universal,
        isSelected: !feature.isSelected,
      }
    ];
    this.setState({
      permissions: newpermissions,
    });
  }

  handleChange(e) {
    if (e.target.name === 'description' && e.target.value.length > 1000) {
      return;
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  handleDisabledChange() {
    this.setState({
      isActive: !this.state.isActive,
    });
  }

  handleSubmit(e) {
    let updateLicenseBody = {...this.state};
    updateLicenseBody.permissions = updateLicenseBody.permissions.filter(f => f.isSelected === true);
    const result = this.props.updateLicense(updateLicenseBody);
    if (result.error) {
      e.preventDefault();
      this.props.showMessageBox({
        title: 'Invalid Entry',
        message: result.errorMessage,
      });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/admin/license-maintenance' />;
    }
    const method = this.props.method;
    const status = this.state.isActive ? 'Active' : 'Inactive';
    const permissionsList = this.state.permissions
      .sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
      .map((feature, i) => {
        const stateFeature = this.state.permissions.filter((f) => f.code === feature.code)[0];
        const isChecked = stateFeature && stateFeature.isSelected;
        return (
          <li className='list-group-item feature-type' key={i} style={{border: 'none', padding: 0, color: '#000', marginBottom: 5}}>
            <div className='form-wrapper'>
              <div className='moo-form-element'>
                <input
                  id={`checkbox-${feature.code}`}
                  name={`checkbox-${feature.code}`}
                  className='AddUser_chkUserFeatures'
                  type='checkbox'
                  checked={isChecked}
                  value={feature.code}
                  onClick={() => this.updateFeature(null, feature.code)}
                />
                <label htmlFor={`checkbox-${feature.code}`}></label>
              </div>
              <div className='form-info-wrapper AddUser_lblUserFeatures' style={{top: '69%'}}>
                <strong>{feature.name}</strong>
              </div>
            </div>
          </li>
        )
      });
    return (
      <Dialog
        size='lg'
        title={ method === 'edit' ? 'Edit License' : 'Add License' }
        backTo='/admin/license-maintenance/'
        yesText='Save'
        yesCallback={this.handleSubmit}
        noCallback={(e) => {
          if (this.checkForDirty.test(e, this.state)) {
            e.preventDefault();
            this.props.setQuestion({
              title: 'Unsaved Changes',
              message: 'You have unsaved changes. Are you sure you want to leave this page?',
              yesCallback: () => this.props.history.push('/admin/license-maintenance/'),
            });
          }
        }}
      >
        <div>
          <section className='section'>
            <div className='row'>
              <div className='col-xs-7'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddLicense_txtStatus'>Status</label>
                    <input value={status} type='text' className='form-control dark-label' name='AddLicense_txtStatus' disabled />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='name'>License name</label>
                    <input value={this.state.name} onChange={this.handleChange} type='text' className='form-control dark-label' name='name' maxLength='255' />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='description'>License description</label>
                    <textarea
                      className='form-control dark-label'
                      htmlFor='description'
                      name='description'
                      onChange={this.handleChange}
                      value={this.state.description}
                      style={{height: 198, padding: '6px 9px'}}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='name'>License SKU</label>
                    <input value={this.state.sku} onChange={this.handleChange} type='text' className='form-control dark-label' name='sku' maxLength='255' />
                  </div>
                </div>
              </div>
              <div className='col-xs-5'>
                <div className='row'>
                  <div className='col-xs-12 form-group'>
                    <label className='text-primary' htmlFor='AddUser_txtPermissions'>Permissions</label>
                    <div className='panel inverse panel-primary permissions-list' style={{margin: 0}}>
                      <div className='panel-body'>
                        <ul className='list-group' style={{marginTop: -9, minHeight: 326}}>
                          { permissionsList }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
            
              </div>
            </div>
            <div className='row'>
              <div className='col-xs-12 form-wrapper small-form' onClick={this.handleDisabledChange}>
                <div className='moo-form-element'>
                  <input type='checkbox' checked={!this.state.isActive} />
                  <label htmlFor='AddUser_chkDisableAccount' style={{top: -9}}></label>
                </div>
                <div className='form-info-wrapper light-label'>
                  <strong>Deactivate license</strong>
                </div>
               </div>
            </div>
          </section>
        </div>
      </Dialog>
    );
  }

}

export default AddEditLicense;



// WEBPACK FOOTER //
// ./src/components/Admin/AddEditLicense.js